// extracted by mini-css-extract-plugin
export var infoItem = "_ts-2";
export var title = "_ts-0";
export var value = "_ts-1";